import type { PartDefinition } from '@rogue/rackbuilder'
import type { SquatStandOptions } from '../../RackTypes'
import { S4Builder } from './s4Builder'
import { SML2CSquatStand } from './variants/SML2CSquatStand'
import { HR2HalfRack } from './variants/HR2HalfRack'
import { SquatStandBuilder } from './squatStandBuilder'

export class SquatStandFactory {
  static build(config: SquatStandOptions): PartDefinition {
    if (config.halfRack) {
      return new HR2HalfRack(config).build()
    }
    
    if (config.isSML2C) {
      return new SML2CSquatStand(config).build()
    }

    if (config.isS4) {
      return new S4Builder(config).build()
    }

    // Standard squat stands: SML-1, SML-2, SML-3, SM-1
    return new SquatStandBuilder(config).build()
  }
}